import { render, staticRenderFns } from "./BaikalAttraction.vue?vue&type=template&id=4430d0f2"
import script from "./BaikalAttraction.vue?vue&type=script&lang=js"
export * from "./BaikalAttraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports